<template>
    <v-card
        flat
    >
        <v-card-title
          class="blue--text"
          style="height: 68px"
        >
          {{ $t('blob.feed.title') }}
        </v-card-title>
        <v-divider class="blue"></v-divider>
        <v-card-text
            class="pa-0"
        >
            <v-list
              v-if="latestUpdate"
              max-height="450"
              class="overflow-y-auto"
            >
                <template v-for="(blob,i) in blobs">
                    <v-list-item
                        :key="i"
                        :to="{ name: 'blob', params: { radarId: blob.radar_id, blobId: blob.id} }"
                    >
                        <v-list-item-icon>
                            <v-icon>mdi-image-filter-tilt-shift</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title
                                    v-text="blob.name"
                            ></v-list-item-title>
                            <v-list-item-subtitle
                                    class="font-weight-thin"
                            >
                                <v-icon size="medium">mdi-radar</v-icon>
                                {{ getRadarName(blob.radar_id) }}
                                <br>
                                <v-icon size="medium">mdi-update</v-icon>
                                {{ blob.updated_at|formatDateTime }}

                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </template>
            </v-list>
        </v-card-text>
    </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'BlobFeed',
    mixins: [],

    computed: {
      ...mapGetters({
        latestUpdate: 'blobs/getLatestBlobUpdate',
        blobs: 'blobs/getLatestBlobs',
        radars: 'radars/getRadars'
      }),
    },

    created () {
      if (!this.latestUpdate) {
        this.$store.dispatch('blobs/loadLatestBlobs')
      }
    },

    methods: {
      getRadarName(id) {
        var radar = this.radars.find(r => r.id === +id);

        return radar !== undefined? radar.name: '';
      }
    }
  }
</script>
